import * as React from 'react';
import { cn } from '@/lib/utils';

interface DataFieldProps {
  label: string;
  value?: React.ReactNode;
  mono?: boolean;
  full?: boolean;
  className?: string;
}

export function DataField({ label, value, mono, full, className }: DataFieldProps): JSX.Element {
  return (
    <div className={cn('space-y-0.5', full && 'col-span-full', className)}>
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className={cn('text-sm', mono && 'font-mono text-xs', !value && 'text-muted-foreground')}>
        {value ?? '—'}
      </div>
    </div>
  );
}
